import useDetectScrollDirection from "./useDetectScrollDirection";

export default useDetectScrollDirection;
